import React, { useEffect } from 'react'
import sharedClasses from '../../Auth/signup.module.css'
import classes from '../../Auth/SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../../assets/images/beneficiary-invite-image.jpg'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../../components/Button/Button'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { BeneficiaryTop } from './BeneficiarySignUp'
import useCompanyLogo from '../../../hooks/useCompanyLogo'
import Loading from '../../../components/loaders/Loading'
import { Redirect } from 'react-router'
import { authSelectors } from '../../../redux/authSlice'
import { getParentRoute } from '../../../util/functions'
import notification from '../../../components/Notification/notification'
import { sendResetLink } from '../../../api/authApi'
import * as yup from 'yup'

const forgotPasswordSchema = yup.object({
    email: yup
        .string()
        .email('Please input a valid email')
        .required('Please input your email'),
})

function BeneficiaryForgotPassword({ match, location }) {
    const dispatch = useDispatch()
    const hasError = useSelector(authSelectors.getHasErrorState)
    const errorMessage = useSelector(authSelectors.getErrorMessageState)
    const success = useSelector(authSelectors.getSuccessState)

    const path = getParentRoute(location.pathname)

    const submitForm = async ({ email }) => {
        const [dismiss] = await notification.loading({
            title: 'Submitting...',
        })
        await dispatch(sendResetLink({ email, isBeneficiary: true }))
        dismiss()
    }

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    useEffect(() => {
        if (success) {
            notification.success({
                title: 'Success',
                description:
                    'Password reset instructions have been sent to your mail',
            })
        }
    }, [success])

    const { domainName } = match.params

    const logoProps = useCompanyLogo(domainName)

    if (logoProps.isFetching) {
        return <Loading />
    }

    if (logoProps.has404Error) {
        return (
            <Redirect
                to={{
                    pathname: '/app/404',
                    state: { finalDestination: true },
                }}
            />
        )
    }

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            <Formik
                initialValues={{
                    email: '',
                }}
                validationSchema={forgotPasswordSchema}
                onSubmit={submitForm}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <BeneficiaryTop logoProps={logoProps} />
                        <h1 className={sharedClasses.formHeader}>
                            Forgot Password
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            smallRadius
                            onClick={handleSubmit}
                        >
                            Submit
                            <ButtonIcon
                                icon={
                                    <ArrowRight
                                        className={sharedClasses.formButtonIcon}
                                    />
                                }
                            />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Back to{' '}
                            <Link
                                to={`${path}/sign-in`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt=""
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default BeneficiaryForgotPassword
